
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ThemeConstantService } from './services/theme-constant.service';
import { SearchPipe } from './pipes/search.pipe';
import {ItemCountComponent} from './components/item-count/item-count.component';
import {HasAnyAuthorityDirective} from './directives';
import {CookieModule} from 'ngx-cookie';
import {IconFilterPipe} from './pipes/iconFilter.pipe';
import { SearchFilterComponent } from 'src/app/shared/components/search-filter/search-filter.component';
import { ErrorTextComponent } from 'src/app/shared/components/error-text/error-text.component';
import { TransformMoneyPipe } from './pipes/transformMoney.pipe';
import { FractionPipe } from './pipes/transformNumberToFraction.pipe';
import { ClipboardModule } from 'ngx-clipboard';
import { DropdownSearchComponent } from './components/dropdown-search/dropdown-search.component';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule  } from 'ng-zorro-antd/select';
import { NzTableModule  } from 'ng-zorro-antd/table';
import { NzTabsModule  } from 'ng-zorro-antd/tabs';
import { NzAvatarModule  } from 'ng-zorro-antd/avatar';
import { NzAlertModule  } from 'ng-zorro-antd/alert';
import { NzProgressModule  } from 'ng-zorro-antd/progress';
import { NzToolTipModule   } from 'ng-zorro-antd/tooltip';
import { NzPopoverModule    } from 'ng-zorro-antd/popover';
import { NzSwitchModule   } from 'ng-zorro-antd/switch';
import { FilterStartEndDateComponent } from './components/filter-start-end-date/filter-start-end-date';
import { ViewNoteComponent } from './components/view-note/view-note.component';
import { InputNotePopUpComponent } from './components/input-note-popup/input-note-popup.component';
import { InputDateComponent } from './components/input-date/input-date';
import { InputNumberComponent } from './components/input-number/input-number';
import { ConfirmPopupComponent } from './components/confirm-popup/confirm-popup.component';
@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        NzIconModule,
        NzTagModule,
        NzBadgeModule,
        NzModalModule,
        NzCardModule,
        NzTabsModule,
        NzListModule,
        NzPageHeaderModule,
        NzFormModule,
        NzLayoutModule,
        NzDropDownModule,
        NzButtonModule,
        NzSelectModule,
        NzTableModule,
        NzAvatarModule,
        NzInputModule,
        NzAlertModule,
        NzPaginationModule,
        NzProgressModule,
        NzToolTipModule,
        NzPopoverModule,
        NzSwitchModule,
        NzDividerModule,
        IconFilterPipe,
        SearchPipe,
        HasAnyAuthorityDirective,
        SearchFilterComponent,
        ErrorTextComponent,
        DropdownSearchComponent, FilterStartEndDateComponent,
        TransformMoneyPipe,
        FractionPipe,
        ViewNoteComponent,
        ClipboardModule,
        InputNotePopUpComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ClipboardModule,
        NzIconModule,
        NzTagModule,
        NzBadgeModule,
        NzModalModule,
        NzCardModule,
        NzTabsModule,
        NzListModule,
        NzPageHeaderModule,
        NzFormModule,
        NzLayoutModule,
        NzDropDownModule,
        NzButtonModule,
        NzSelectModule,
        NzTableModule,
        NzAvatarModule,
        NzInputModule,
        NzAlertModule,
        NzPaginationModule,
        NzProgressModule,
        NzToolTipModule,
        NzPopoverModule,
        NzSwitchModule,
        NzDividerModule,
        CookieModule.forRoot()
    ],
    declarations: [
        IconFilterPipe,
        SearchPipe,
        DropdownSearchComponent,
        ItemCountComponent,
        ErrorTextComponent,
        HasAnyAuthorityDirective,
        SearchFilterComponent,
        ConfirmPopupComponent,
        TransformMoneyPipe,
        FractionPipe,
        ViewNoteComponent,
        FilterStartEndDateComponent,
        InputNotePopUpComponent,
        InputDateComponent,
        InputNumberComponent
        
    ],
    providers: [
        ThemeConstantService
    ]
})

export class SharedModule { }
